export default __webpack_public_path__ + "static/media/Financial Guide booklet.e2a8fbab.png";